export default {
    head_practitioner: {
        value: [],
    },
    healthcare_provider: {
        value: [],
    },
    last_activity: {
        value: [],
    },
    lifestyle: {
        value: [],
    },
    messages: {
        value: [],
    },
    pregnancy: {
        value: [],
    },
    questionnaire: {
        value: [],
    },
    search: {
        value: '',
    },
    status: {
        value: [],
    },
    page: {
        value: 0,
    },
};
